<tui-root class="h-full">
  <router-outlet></router-outlet>
</tui-root>
